module.exports = __webpack_public_path__ + "img/gsa.903e413a.jpg";